import Reveal from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const STEPS = [
    {
        num: "01",
        title: "Audit",
        copy: "We review your current advertising, search presence, competition, conversion tracking, and opportunities.",
        testid: "step-audit",
    },
    {
        num: "02",
        title: "Build",
        copy: "We develop the campaign strategy, tracking infrastructure, advertising assets, and landing-page experience.",
        testid: "step-build",
    },
    {
        num: "03",
        title: "Launch",
        copy: "Your campaigns go live with carefully selected audiences, keywords, locations, and messaging.",
        testid: "step-launch",
    },
    {
        num: "04",
        title: "Optimize",
        copy: "We continuously analyze performance and improve campaigns based on actual conversion and lead-quality data.",
        testid: "step-optimize",
    },
];

export const HowItWorks = () => (
    <section id="how-it-works" className="py-24 md:py-32 lg:py-40">
        <div className="shell">
            <SectionHeading
                eyebrow="How It Works"
                title="A simpler way to grow your firm."
            />
            <div className="mt-16 md:mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
                {STEPS.map((s, i) => (
                    <Reveal key={s.num} delay={0.08 + i * 0.1} className="h-full">
                        <div
                            data-testid={s.testid}
                            className="relative pt-8 border-t border-white/10 h-full"
                        >
                            <span
                                aria-hidden="true"
                                className="absolute top-[-3px] left-0 h-[5px] w-[5px] bg-brass-500"
                            />
                            <p className="text-xs tracking-[0.25em] text-brass-500 font-semibold">
                                {s.num}
                            </p>
                            <h3 className="mt-5 font-serif text-2xl md:text-3xl text-white">
                                {s.title}
                            </h3>
                            <p className="mt-4 text-sm md:text-base leading-relaxed text-zinc-400">
                                {s.copy}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default HowItWorks;
